import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ManageStandardsActions } from './manage-standards.actions';
import { ManageStandardsSrvice } from '../../service/manage-standards.service';


@Injectable()
export class ManageStandardsEffects {

  getStandards$ = createEffect(
    (rs: ManageStandardsSrvice = inject(ManageStandardsSrvice)) => {
      return this.actions$.pipe(

        ofType(ManageStandardsActions.loadManageStandards),
        mergeMap(({ campaignId, parameters }) =>
          rs.getStandards(campaignId, parameters).pipe(
            map((standards) => {
              return ManageStandardsActions.loadManageStandardsSuccess({
                standards
              });
            }),
            catchError((error) => of(ManageStandardsActions.loadManageStandardsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );


  getAllStandards$ = createEffect(
    (rs: ManageStandardsSrvice = inject(ManageStandardsSrvice)) => {
      return this.actions$.pipe(

        ofType(ManageStandardsActions.loadAllManageStandards),
        mergeMap(({ campaignId, parameters }) =>
          rs.getStandards(campaignId, parameters).pipe(
            map((standards) => {
              return ManageStandardsActions.loadAllManageStandardsSuccess({
                standards
              });
            }),
            catchError((error) => of(ManageStandardsActions.loadAllManageStandardsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );



  createOrUpdateStandards$ = createEffect(
    (rs: ManageStandardsSrvice = inject(ManageStandardsSrvice)) => {
      return this.actions$.pipe(
        ofType(ManageStandardsActions.createOrUpdateStandards),
        concatMap(({ campaignId, input, parameters }) =>
          rs.createOrUpdateStandard(campaignId, input).pipe(
            mergeMap((createOrUpdate) => [
              ManageStandardsActions.createOrUpdateStandardsSuccess({ createOrUpdate }),
              ManageStandardsActions.loadAllManageStandards({
                campaignId, parameters: {
                  page: 0,
                  order: {
                    sortField: null,
                    sortDirection: "ASC"
                  },
                  search: null,
                  filters: {},
                  rows: 1000000
                }
              }),
              ManageStandardsActions.loadManageStandards({
                campaignId, parameters
              })
            ]
            ),
            catchError((error) => of(ManageStandardsActions.createOrUpdateStandardsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );


  deleteStandards$ = createEffect(
    (rs: ManageStandardsSrvice = inject(ManageStandardsSrvice)) => {
      return this.actions$.pipe(
        ofType(ManageStandardsActions.deleteStandard),
        concatMap(({ campaignId, id }) =>
          rs.deleteStandard(campaignId, id).pipe(
            mergeMap((deleteStandard) => [
              ManageStandardsActions.deleteStandardSuccess({ deleteStandard, id }),
              ManageStandardsActions.loadAllManageStandards({
                campaignId, parameters: {
                  page: 0,
                  order: {
                    sortField: null,
                    sortDirection: "ASC"
                  },
                  search: null,
                  filters: {},
                  rows: 1000000
                }
              })
            ]
            ),
            catchError((error) => of(ManageStandardsActions.deleteStandardFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  constructor(private actions$: Actions) { }
}
